<a
  href="{{ link }}"
  class="solution-card"
  [ngClass]="{ alternate: !alternate }"
>
  <div class="solution-card-image">
    <img src="{{ image }}" alt="{{ title }}" />
  </div>
  <div class="solution-card-content">
    <h4>
      {{ title }}
      <span class="icon">
        <svg
          width="50"
          height="52"
          viewBox="0 0 50 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="1.43637"
            y1="49.7862"
            x2="48.5789"
            y2="2.64365"
            stroke="#FAF2F2"
            stroke-width="4"
          />
          <line
            x1="11.8926"
            y1="2.05786"
            x2="49.9934"
            y2="2.05786"
            stroke="#FAF2F2"
            stroke-width="4"
          />
          <line
            x1="47.9922"
            y1="42.4824"
            x2="47.9922"
            y2="4.05796"
            stroke="#FAF2F2"
            stroke-width="4"
          />
        </svg>
      </span>
    </h4>
    <p>{{ description }}</p>
    <a href="{{ link }}">
      <span class="icon">
        <svg
          width="50"
          height="52"
          viewBox="0 0 50 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="1.43637"
            y1="49.7862"
            x2="48.5789"
            y2="2.64365"
            stroke="#FAF2F2"
            stroke-width="4"
          />
          <line
            x1="11.8926"
            y1="2.05786"
            x2="49.9934"
            y2="2.05786"
            stroke="#FAF2F2"
            stroke-width="4"
          />
          <line
            x1="47.9922"
            y1="42.4824"
            x2="47.9922"
            y2="4.05796"
            stroke="#FAF2F2"
            stroke-width="4"
          />
        </svg>
      </span>
    </a>
  </div>
</a>
